function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLanguageRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26 18v-2a7.371 7.371 0 01-3.3-.76A8.27 8.27 0 0024.78 12H26v-2h-4V8h-2v2h-4v2h1.22a8.27 8.27 0 002.08 3.24A7.371 7.371 0 0116 16v2a9.39 9.39 0 005-1.43A9.39 9.39 0 0026 18zm-6.63-6h3.26A7.18 7.18 0 0121 14.09 7.18 7.18 0 0119.37 12z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 2H4a2 2 0 00-2 2v19a2 2 0 002 2h7.5l4.5 5 4.5-5H28a2 2 0 002-2V4a2 2 0 00-2-2zm0 21h-8.39l-.6.66L16 27l-3-3.35-.6-.66H4V4h24v19z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19 18l3.17-9.09h2.25L14.77 18h-2l-.58-1.82H8.66L8.09 18h-1.9zm3-3.44h2.49l-1.25-3.93-1.24 3.93z",
    fill: props.color
  }));
}

export default SvgIconLanguageRexOutline;